import { Flex, Icon, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { LogoAccounting, LogoShine } from '../../../../../../assets/images'
import { ProductSource } from '../../enums/productSource'
import * as Styled from './styles'

interface OrganizationInfoBoxProps {
  organizationName: string
  ownerName: string
  ownerPhoneNo?: string
  ownerEmail?: string
  siretNo?: string
  source: ProductSource
}

export const OrganizationInfoBox = ({
  organizationName,
  ownerName,
  ownerPhoneNo,
  ownerEmail,
  source,
  siretNo,
}: OrganizationInfoBoxProps): ReactElement => {
  const { t } = useTranslation()

  const isBankingProduct = source === ProductSource.BANKING
  const productName = isBankingProduct
    ? t('bank_connection.shine_connect_modal.banking_title')
    : t('bank_connection.shine_connect_modal.accounting_title')

  return (
    <Styled.OrganizationInfoBoxContainer>
      <Flex>
        {isBankingProduct ? <LogoShine width="23" height="23" /> : <LogoAccounting />}
        <Space size="s4" horizontal />
        <Text variant="bodyLG" weight="bold">
          {productName}
        </Text>
      </Flex>
      <Styled.DetailsWrapper>
        <Flex flexDirection="column">
          <Text colorVariant="secondary">{organizationName}</Text>
          {isBankingProduct && (
            <Text colorVariant="secondary">
              {t('bank_connection.shine_connect_modal.siret_label')} {siretNo}
            </Text>
          )}
        </Flex>
        <Flex flexDirection="column">
          <Text variant="bodyMD">{ownerName}</Text>
          <Flex gap={Spacing.S4} alignItems="center">
            <Icon icon={isBankingProduct ? 'phone' : 'mail'} size="xs" />
            <Text variant="bodySM" colorVariant="secondary">
              {isBankingProduct ? ownerPhoneNo : ownerEmail}
            </Text>
          </Flex>
        </Flex>
      </Styled.DetailsWrapper>
    </Styled.OrganizationInfoBoxContainer>
  )
}
